import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chart = _resolveComponent("Chart")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.$store.getters.getAllRequests == _ctx.$store.getters.getDoneRequests)
      ? (_openBlock(), _createBlock(_component_Chart, {
          langs: _ctx.langs,
          key: _ctx.key
        }, null, 8, ["langs"]))
      : _createCommentVNode("", true),
    _createTextVNode(" " + _toDisplayString(_ctx.$store.getters.getAllRequests) + " " + _toDisplayString(_ctx.$store.getters.getDoneRequests), 1)
  ]))
}